import { j as l } from "../../../_virtual/jsx-runtime.js";
import { useState as f, useCallback as S } from "react";
import C from "../../../assets/icons/ChevronDown.js";
import E from "../../../assets/icons/Search.js";
import { DropdownMenu as F, DropdownMenuTrigger as L, DropdownMenuContent as P, DropdownMenuItem as p } from "../../ui/dropdown-menu.js";
import { debounce as R, cn as s } from "../../../lib/utils.js";
import T from "../../../node_modules/react-loading-skeleton/dist/index.js";
const K = ({
  triggerContent: h,
  options: a,
  triggerClassName: b,
  triggerContentClassName: v,
  listClassName: j,
  itemClassName: o,
  onOptionSelect: u,
  searchable: d,
  searchPlaceholder: g = "Search",
  searchClassName: w,
  onSearchChange: t,
  noSearchResults: y = "No results found",
  defaultValue: N = null,
  isLoading: c = !1
}) => {
  const [n, i] = f(N), [m, D] = f(""), r = n ? a.find((e) => e.value === n) : null, x = a.filter(
    (e) => e.label.toLowerCase().includes(m.toLowerCase())
  ), k = S(
    R((e) => {
      t == null || t(e);
    }, 800),
    [t]
  ), I = (e) => {
    e.stopPropagation(), e.preventDefault(), D(e.target.value), k(e.target.value);
  }, M = (e) => {
    n === e ? (i(null), u(null)) : (i(e), u(a.find((V) => V.value === e) || null));
  };
  return /* @__PURE__ */ l.jsxs(F, { children: [
    /* @__PURE__ */ l.jsx(
      L,
      {
        className: s(
          "focus:outline-none focus:ring-0 hover:border-none border-none",
          b
        ),
        children: /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: s(
              "bg-white text-gray-900 hover:bg-neteera-teal-100 h-8 min-w-8 px-3 py-2 text-sm font-medium inline-flex items-center justify-center gap-2 rounded-lg w-fit focus:outline-none focus:ring-0 hover:border-none border-none",
              v
            ),
            children: [
              (r == null ? void 0 : r.label) ?? h,
              /* @__PURE__ */ l.jsx(C, { width: 16, height: 16 })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ l.jsxs(
      P,
      {
        align: "start",
        className: s("px-4 py-2 gap-2", j),
        children: [
          d && /* @__PURE__ */ l.jsx("div", { className: s("pb-1", w), children: /* @__PURE__ */ l.jsxs("div", { className: "flex items-center border border-neteera-teal-400 rounded px-3 mx-0", children: [
            /* @__PURE__ */ l.jsx(E, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
            /* @__PURE__ */ l.jsx(
              "input",
              {
                className: "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
                placeholder: g,
                value: m,
                onChange: I
              }
            )
          ] }) }),
          !c && d && !x.length && /* @__PURE__ */ l.jsx(
            p,
            {
              className: s("text-base px-2 -mx-2 py-2.5", o),
              disabled: !0,
              children: y
            }
          ),
          x.map(
            (e) => c ? /* @__PURE__ */ l.jsx(T, { height: 10 }) : /* @__PURE__ */ l.jsx(
              p,
              {
                textValue: e.value,
                onSelect: () => M(e.value),
                disabled: e.disabled ?? !1,
                className: s("text-base px-2 -mx-2 py-2.5", (r == null ? void 0 : r.value) === e.value ? "current-option" : "", o),
                children: e.label
              },
              e.value
            )
          )
        ]
      }
    )
  ] });
};
export {
  K as default
};
